import FeedingService from '../services/FeedingService';
import router from '@/router';

const getDefaultState = () => ({
  feeding: {
    studentId: '',
    student_uuid: '',
    date: null,
    category: '',
  },
  studentFeedings: [],
  oneDateFeeding: [],
  feedingSummaryTable: [],
});

const feedings = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    addFeedingRecords(state, payload) {
      state.studentFeedings.push({
        studentId: payload.studentId,
        student_uuid: payload.uuid,
        date: payload.date,
        category: payload.category,
      });
    },
    updateStudentRecords(state) {
      FeedingService.updateFeedingRecords(state.studentFeedings);
    },
    oneDateFeeding(state, val) {
      state.oneDateFeeding = val;
    },
    bulkAddDate(state, val) {
      state.oneDateFeeding.map(item => (item.feeding_date = val));
    },
    feedingSummaryTable(state, val) {
      state.feedingSummaryTable = val;
    },
    resetFeedings(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async GET_FEEDING_RECORDS(context) {
      context.rootState.feedings.studentFeedings = [];
      const studentRecords = await FeedingService.fetchFeedingsByStudent({
        studentId: router.currentRoute.params.id,
      });
      context.rootState.feedings.studentFeedings = studentRecords.data.feedings;
    },
    async ADD_BULK_FEEDING({ state }) {
      await FeedingService.addOneDateFeedingeByTeacher(state.oneDateFeeding);
    },
    async ADD_FEEDING_RECORD({ commit }, payload) {
      await commit('addFeedingRecords', payload);
    },
    async UPDATE_STUDENT_FEEDING_RECORDS({ commit }, payload) {
      await commit('updateStudentRecords', payload);
    },
    async GET_ONE_DATE_FEEDING(context, teacherId, date) {
      const payload = await FeedingService.fetchOneDateFeedingByTeacher(
        teacherId,
        date
      );
      const data = payload.data.results;
      context.commit('oneDateFeeding', data);
    },
    async ADD_ONE_DATE_FEEDING({ state }) {
      await FeedingService.addOneDateFeedingByTeacher(
        {
          teacher_id: router.currentRoute.params.id,
        },
        state.oneDateFeeding
      );
    },
    async UPDATE_ONE_DATE_FEEDING({ state }, context) {
      const payload = await FeedingService.fetchOneDateFeedingByTeacher({
        teacher_id: router.currentRoute.params.id,
        date: state.feeding_date,
      });
      const data = payload.data.results;
      context.commit('oneDateFeeding', data);
    },
    async GET_FEEDING_SUMMARY_TABLE(context) {
      const payload = await FeedingService.fetchFeedingSummaryTable({
        teacher_id: router.currentRoute.params.id,
      });
      const data = payload.data.results;
      context.commit('feedingSummaryTable', data);
    },
    async BULK_UPDATE_ALL({ state }) {
      await FeedingService.bulkUpdateOneDateFeedingByTeacher(
        state.oneDateFeeding
      );
    },
    async RESET_FEEDINGS_STATE(context) {
      await context.commit('resetFeedings');
    },
  },
  getters: {
    getStudentFeedings: state =>
      state.studentFeedings.map(item => {
        item.category = item.category.toString();
        return item;
      }),
  },
};

export default feedings;
